export default __webpack_public_path__ + "static/SR USA - Halal - Certificate-f631eb10069a514fbfae921dc25850f2.pdf";